// extracted by mini-css-extract-plugin
module.exports = {"container":"KtKP0u","text":"_2U1_H2","action":"_3ZdPdA","shine-lines":"_1aEvjs"};